<div class="container-fluid maap-root-container" style="overflow: unset; background: unset; box-shadow: none; border: none;">
    <app-header [showWitness]="true"></app-header>
    <app-sidebar></app-sidebar>
    <div style="margin-top: 60px; margin-left: 80px; padding-top: 20px;">
        <header class="standalone-page-header">
            <h1 class="standalone-page-title">Helpful documents</h1>
        </header>
        <div class="col-12">
    <p-table [value]="records" [lazy]="true" (onLazyLoad)="loadRecordsLazy()">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th id="headerStyle">
                    Documents             
                </th>
                <th id="headerStyle">  
                    User Guide
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr class="maap-row-level1">
            <td><a href="{{url}}{{getField(rowData, 'dd')}}" target="_blank">{{getField(rowData, 'dd')}}</a></td>
            <td><a href="{{url}}{{getField(rowData, 'rb')}}" target="_blank">{{getField(rowData, 'rb')}}</a></td>
            <td><a href="{{url}}{{getField(rowData, 'ug')}}" target="_blank">{{getField(rowData, 'ug')}}</a></td>
            </tr>
        </ng-template>
    </p-table>
        </div>
    </div>
</div>
